/* AF1C cart pill sync — Shopify version.
 * Fetches cart.js on page load to render the count.
 * Listens for storage/pageshow to stay live across navigation.
 */
(function () {
  function render(bump) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          var prev = el.textContent;
          el.textContent = total > 99 ? '99+' : String(total);
          if (bump && String(total) !== prev) {
            el.classList.add('is-bumping');
            setTimeout(function () { el.classList.remove('is-bumping'); }, 240);
          }
        });
        document.querySelectorAll('[data-cart-indicator]').forEach(function (el) {
          el.dataset.cartEmpty = total === 0 ? 'true' : 'false';
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { render(false); });
  } else {
    render(false);
  }
  // Repaint when returning from Shopify checkout
  window.addEventListener('pageshow', function () { render(false); });
})();
